import React from 'react';
import RichTextEditorTipTap from '../richtext/RichTextEditorTipTap';
import { ensureTipTapFormat } from '../../lib/richtext/tiptapConverters';

// Wrapper component to map note props to TipTap format
export default function NoteEditor({ note, onChange, placeholder, ...otherProps }) {
  console.log('📝 NoteEditor received props:', { note, onChange: typeof onChange, placeholder, otherProps });
  
  // Map note object to TipTap format
  const value = ensureTipTapFormat({
    content_json: note?.content_json || note?.raw,
    content_html: note?.content_html || note?.html,
    content_plain: note?.content_plain || note?.text
  });

  console.log('📝 NoteEditor mapped value:', value);

  return (
    <RichTextEditorTipTap
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...otherProps}
    />
  );
}